import { get, AHPLUS_API_URL } from "api/ky";

export const POLICY_URL = `${AHPLUS_API_URL}/api/v2/user_policy`;
export const AIR_BUNDLE_SUBSCRIPTION_URL = `${AHPLUS_API_URL}/api/v2/user_policy/air_bundle_subscription`;

export const fetchPolicy = async () => {
  return await get(POLICY_URL);
};

export const fetchAirBundleSubscription = async () => {
  return await get(AIR_BUNDLE_SUBSCRIPTION_URL);
};
